/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/search/searchRouting.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { generatePath } from 'quartz-routing/react-router';
import { RESULTS_URL_FRAGMENT } from '../../constants/Navigation.legacy';
import { FILTER_CONSTS, FILTER_TYPES } from 'academy-common-lib/constants/TopFilterConstants';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/search/searchRouting.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const getSearchUrl = ({
  searchTerm,
  language,
  showOnlyCerts,
  tool,
  category,
  contentType,
  contentSource
}) => {
  const urlParams = new URLSearchParams();
  if (searchTerm) urlParams.set(FILTER_TYPES.SEARCH, searchTerm);
  if (contentType) urlParams.set(FILTER_TYPES.CONTENT_TYPE, contentType);
  if (contentSource) urlParams.set(FILTER_TYPES.CONTENT_SOURCE, contentSource);
  if (language) {
    if (Array.isArray(language)) {
      language.forEach(lang => urlParams.append(FILTER_TYPES.LANGUAGE, lang.toUpperCase()));
    } else {
      urlParams.set(FILTER_TYPES.LANGUAGE, language.toUpperCase());
    }
  }
  if (showOnlyCerts) urlParams.set(FILTER_TYPES.AWARD_TYPE, FILTER_CONSTS.AWARD_TYPES.ONLY_SHOW_CERTIFICATE_COURSES);
  if (tool && !Array.isArray(tool)) {
    urlParams.set(FILTER_TYPES.TOOLS, tool);
  }
  if (category) urlParams.set(FILTER_TYPES.CATEGORY, category);
  const pathname = generatePath(RESULTS_URL_FRAGMENT);
  const search = urlParams.toString().replace(/\+/g, '%20');
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};